import Tag from "@common/components/Tag/Tag";
import { vars } from "@common/styles";
import styled from "styled-components";

export const RowTag = styled(Tag)`
  height: 2.4rem;
  color: ${vars.colors.grey60};
  margin: 0 1rem;
`;
